<template>
  <main class="home">
    <section class="intro">
          <div class="content">
            <img class="mb-2 imgbanner" src="../assets/development_1.gif" />
            <h1 class="title"><b>Hourly Software Development</b> for Businesses <b>That Need to Move Fast</b></h1>
            <h2 class="mt-3 mb-3">Accelerate your growth with a flexible, expert team that turns your ideas into agile, scalable solutions built to streamline your operations.</h2>
            <ButtonContactComponent class="mr-2" text="Contact Expert" variant="warning" icon="people" />
            <ButtonComponent text="Define your needs" variant="primary" icon-position="end" icon="arrow-right" href="/login" />
          </div>
    </section>
    <!--<BannerMultiProductComponent :items="banner_items" background="#000000" country="USA" lang="EN" />-->
    <ProductNavComponent background="black" text-color="white" lang="en" />
    <DeckComponent id="what" title="Coolest Development Services" description="We develop for you to exceed your goals. We are ready to build and release your solutions." variant="blue" :items="services" />
    <BannerTipComponent
          icon="https://cdn.systemico.net/systemico/icons/icon-systemico--color.svg"
          message="Yep ... software development for your company, pay what do you need and impulse your goals."
          author=""
          background="#222222"
          textColor="#f8f8f8"
    />
    <BannerBenefitsComponent
          title="Always improving our method to generate a smart development."
          :items="benefits"
          background="#fefefe"
          textColor="#444444"
    />
    <PresentationComponent id="features" title="Systemico / Services / <b>Development</b>" :topics="topics" lang="en" />
    <PricingPlansComponent
        :productId="13"
        :paymentsHost="$paymentsHost"
        currency="USD"
        :lang="$props.lang"
        action="redirect"
        urlButton="https://systemico.net/signup"
        :trialLimit="7"
        :title="pricingTitle[$props.lang]"
        :subtitle="pricingSubTitle[$props.lang]"
    >
    </PricingPlansComponent>
    <FooterSystemicoComponent lang="en" />
  </main>
</template>

<script>
// @ is an alias to /src
import BannerTipComponent from "../packages/systemico.ui/components/banners/BannerTipComponent.vue";
import PresentationComponent from "../packages/systemico.ui/components/slides/PresentationComponent.vue";
import FooterSystemicoComponent from "../packages/systemico.ui/components/footers/FooterSystemicoComponent.vue";
import BannerMultiProductComponent from "../packages/systemico.ui/components/banners/BannerMultiProductComponent.vue";
import BannerBenefitsComponent from "../packages/systemico.ui/components/banners/BannerBenefitsComponent.vue";
import DeckComponent from "../packages/systemico.ui/components/cards/DeckComponent.vue";
import ProductNavComponent from "../packages/systemico.ui/components/navs/ProductNavComponent.vue";
import ButtonComponent from "@/packages/systemico.ui/components/buttons/ButtonComponent.vue";
import ButtonContactComponent from "@/packages/systemico.ui/components/buttons/ButtonContactComponent.vue";
import PricingPlansComponent from "@/packages/systemico.ui/components/pricing/PricingPlansComponent.vue";

export default {
  name: 'HomeView',
  props: {
    lang: {
      type: String,
      default: 'EN'
    }
  },
  data: function () {
    return {
      pricingTitle: {
        EN: 'Pricing & Plans',
        ES: 'Precios y Planes',
        FR: 'Tarification & Plans'
      },
      pricingSubTitle: {
        EN: 'One year of service and updates with one payment.',
        ES: 'Un año de servicio y actualizaciones con un solo pago.',
        FR: 'Un an de service et de mises à jour avec un seul paiement.'
      },
      banner_items: [
        {
          id: 1,
          title: 'Development Services',
          subtitle: 'We provide on demand high quality development to create API REST, SOAP services and Bots  with Python, Java and Php.',
          image: 'https://cdn.systemico.net/systemico/web/headers/header_16.svg',
          backgroundImage: '',
          buttons: [
            { id: 1, text: 'Start your development', variant: 'primary', link: 'https://systemico.dev/signup?context=developmen', icon:'patch-check-fill' },
            { id: 2, text: "I'm a happy client", variant: 'secondary', link: 'https://systemico.dev/login?context=development', icon:'code-square' }
          ],
          show: true
        }
      ],
      benefits: [
        { id: 1, title: 'Permanent Support', description: 'Standards, clean code and better practice to let a almost magical support.', icon: 'https://cdn.systemico.net/systemico/icons/icon--soporte.svg' },
        { id: 2, title: 'Knowledge', description: 'Each day our team learn, test and improve different solutions to increase our skills with the best.', icon: 'https://cdn.systemico.net/systemico/icons/icon-code.svg' },
        { id: 3, title: 'Empathy', description: 'We understand your needs and dreams, we are ready to help, share and improve.', icon: 'https://cdn.systemico.net/systemico/icons/icon--cool.svg' },
        { id: 4, title: 'Confidence', description: '+15 years developing software around the globe using different technologies, methodologies and techniques.', icon: 'https://cdn.systemico.net/systemico/icons/icon-check--orange.svg' }
      ],
      services: [
        { id: 1, title: 'API development.', description: 'API development for REST and SOAP with testing endpoints and documentation.', image: "https://cdn.systemico.net/systemico/web/cards/headers/header-1.svg", link: '/api', button: 'Learn more' },
        { id: 2, title: 'Bot Development.', description: 'API development for REST and SOAP with testing endpoints and documentation.', image: "https://cdn.systemico.net/systemico/web/cards/headers/header-2.svg", link: '/bots', button: 'Learn more' },
        { id: 3, title: 'Dashboards Development.', description: 'API development for REST and SOAP with testing endpoints and documentation.', image: "https://cdn.systemico.net/systemico/web/cards/headers/header-4.svg", link: '/dashboards', button: 'Learn more' },
        { id: 3, title: 'Cron Services.', description: 'API development for REST and SOAP with testing endpoints and documentation.', image: "https://cdn.systemico.net/systemico/web/cards/headers/header-3.svg", link: '/cron', button: 'Learn more'}
      ],
      topics: [
        { id: 1, topic: 'Brief', content: '<b>Systemico</b> develop solutions for small business, startups in different stages and corporations different targets and industries.<br><br>We works with a professional team to use <b>AI, Data Analytics, Big Data and more</b> to create solutions to solve critical and common problems in different industries, countries and markets. ', image: '' },
        { id: 2, topic: 'Methodology', content: ['1. Needs transformed in requirements. \n', '2. Defining acceptance criteria. \n', '3. Selecting the correct programming language. \n', '4. Implementing the code. \n', '5. Release a beta version.', '6. Testing.', '7. Approval.', '8. Release to production.'], image: '' },
        { id: 3, topic: 'Innovative Aspects', content: ['1. Experience and knowledge.', '2. Multiple enviroments to test.', '3. 100% Web.', '4. Chat to interact with te team.', '5. Project Management Platform to monitor the project.', '6. Frameworks and tools available.'], image: '' },
        { id: 4, topic: 'Fanatical Support', content: 'Support online and available from <a href="https://systemico.dev/">systemico.net</a> or authorized channels.', image: '' },
        { id: 5, topic: 'Thanks', content: '<b>Systemico</b> is the opportunity to create high quality technologies to innovate and add value to your services.', image: '' },
      ],
      plans: [
        {
          id: 1,
          title: 'Starter',
          description: 'Initial development for a small business, startup or a new product.',
          features: [
            { id: 1, value: '<b>20 hours of development.</b>' },
            { id: 2, value: 'Developed with Python <small class="font-italic">(Flask)</small>.' },
            { id: 3, value: 'Documentation included.' },
            { id: 4, value: '1 month of technical support.' },
            { id: 5, value: 'Endpoint beta for testing and acceptance.' },
            { id: 6, value: 'The Better practice of industry.' },
            { id: 7, value: 'Exceptions monitor included.' },
            { id: 8, value: 'Code for data analytics, reports, notifications, authentication and more.' },
          ],
          pricing: '$1000',
          frecuency: 'once',
          currency: 'USD',
          labelButton: 'Get Now',
          noteButton: 'We provide you a platform to manage your requirements, deliveries, billing and support.',
          link: 'https://systemico.dev/signup?dplan=1'
        },
        {
          id: 1,
          title: 'Professional',
          description: 'Professional development for small business, startup or a new product.',
          features: [
            { id: 1, value: '<b>50 hours of development.</b>>' },
            { id: 2, value: 'Developed with Python <small class="font-italic">(Flask)</small>.' },
            { id: 3, value: 'Documentation included.' },
            { id: 4, value: '1 month of technical support.' },
            { id: 5, value: 'Endpoint beta for testing and acceptance.' },
            { id: 6, value: 'The Better practice of industry.' },
            { id: 7, value: 'Exceptions monitor included.' },
            { id: 8, value: 'Code for data analytics, reports, notifications, authentication and more.' },
          ],
          pricing: '$2500',
          frecuency: 'once',
          currency: 'USD',
          labelButton: 'Get Now',
          noteButton: 'We provide you a platform to manage your requirements, deliveries, billing and support.',
          link: 'https://systemico.dev/signup?dplan=2'
        },
        {
          id: 1,
          title: 'ScaleUp',
          description: 'Large development for small business, startup or a new product.',
          features: [
            { id: 1, value: '<b>100 hours of development.</b>' },
            { id: 2, value: 'Developed with Python <small class="font-italic">(Flask)</small>.' },
            { id: 3, value: 'Documentation included.' },
            { id: 4, value: '1 month of technical support.' },
            { id: 5, value: 'Endpoint beta for testing and acceptance.' },
            { id: 6, value: 'The Better practice of industry.' },
            { id: 7, value: 'Exceptions monitor included.' },
            { id: 8, value: 'Code for data analytics, reports, notifications, authentication and more.' },
          ],
          pricing: '$5000',
          frecuency: 'once',
          currency: 'USD',
          labelButton: 'Get Now',
          noteButton: 'We provide you a platform to manage your requirements, deliveries, billing and support.',
          link: 'https://systemico.dev/signup?dplan=3'
        }
      ]
    }
  },
  components: {
    PricingPlansComponent,
    ButtonContactComponent,
    ButtonComponent,
    PresentationComponent,
    ProductNavComponent,
    DeckComponent,
    BannerBenefitsComponent,
    BannerTipComponent,
    BannerMultiProductComponent,
    FooterSystemicoComponent
  }
}
</script>
<style lang="scss" scoped>
@import '../packages/systemico.ui/variables.scss';
.home{
  .intro {
    background-image: radial-gradient(#ccc 1px, transparent 1px);
    background-size: 20px 20px;
    min-height: 80vh;
    height: auto;
    text-align: center;
    .content {
      padding-top: 3rem;
      padding-bottom: 3rem;
      max-width:1280px;
      margin:auto;
      .title{
        font-size: 4rem;
        font-weight: 600;
        color: #484848;
        @media (max-width: 768px) {
          font-size: 2rem;
        }
      }
      h2{
        font-size: 2rem;
        @media (max-width: 768px) {
          font-size: 1.5rem;
        }
      }
    }
  }
}
.imgbanner{
  height: 420px;
  @media (max-width: 768px) {
    height: 30vh;
  }

}
</style>
